var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveToolDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 10,
    height: 10,
    transform: "translate(408 8)",
    fill: "#a5ff7c",
    stroke: "#a5ff7c",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_93",
    "data-name": "Mask Group 93",
    transform: "translate(-408 -8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(403 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M15,5.875,14.125,5,10,9.125,5.875,5,5,5.875,9.125,10,5,14.125,5.875,15,10,10.875,14.125,15,15,14.125,10.875,10Z",
    fill: "#a5ff7c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveToolDark);
export default __webpack_public_path__ + "static/media/remove-tool-dark.0048ace25f8b7a3a86bc18941427cc27.svg";
export { ForwardRef as ReactComponent };